/**
 * AccumulatedText - Web Stub
 *
 * Web version of LetterThrowingAnimation doesn't use this component
 * (it uses inline text display instead). This stub exists to satisfy
 * the export contract and prevent Metro bundler errors.
 *
 * The native version uses react-native-reanimated which has limited
 * web support, so we provide this minimal implementation.
 */

import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import type { AccumulatedTextProps } from './types';

/**
 * Web stub - not used in web animation
 * LetterThrowingAnimation.web.tsx uses inline text display
 */
export default function AccumulatedText({
  landedText,
}: AccumulatedTextProps) {
  // Simple fallback (never actually rendered in web animation)
  return (
    <View style={styles.container}>
      <Text style={styles.text}>{landedText}</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 20,
  },
  text: {
    color: '#FFFFFF',
    fontSize: 24,
    fontWeight: '700',
    textAlign: 'center',
  },
});
